import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Collapse, Button } from 'react-bootstrap';
import cx from 'classnames';

import ReportUserModal from '../ReportUserModal';
import ThankYouModal from '../ThankYouModal';
import Reviews from './Reviews';
import Link from '../Link';
import PanelWrapper from './ManageListing/PanelWrapper';
import DashBoardSideMenu from '../Dashboard/DashBoardSideMenu';

import { openReportUserModal } from '../../actions/modalActions';
import messages from '../../locale/messages';

import { CommonAngleDownIcon, CommonAngleUpIcon, CommonFlagIcon, LinkIndicateIcon } from '../Common/Assets/SvgComponent/commonSvgIcon';

import s from './ViewProfile.css';
import withStyles from 'isomorphic-style-loader/withStyles';

const ViewProfile = ({ data, isUser = false, loadMore, profileId }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const userProfileId = useSelector(state => state?.account?.data?.profileId);
  const isAuthenticate = useSelector(state => state?.runtime?.isAuthenticated);

  const date = moment(Number(data.createdAt)).format('MMMM YYYY');
  const count = 150;
  const firstArray = data?.info?.slice(0, count);
  const restArray = data?.info?.slice(count);
  const dotString = restArray && restArray.length > 0;

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div className={cx('ViewProfile')}>
      <Grid fluid>
        <div className={s.viewProfileGrid}>
          <div>
            <DashBoardSideMenu isProfilePage={true} isUser={isUser} data={data} />
          </div>
          <div>
            <div className={s.borderCommon}>
              <div className={s.paddingOne}>
                <div className={cx(s.textalign, 'textAlignRightRtl', s.profileFlex)}>
                  <div>
                    <h1 className={s.profileTitle}>
                      <FormattedMessage {...messages.hey} /> {data.firstName}!
                    </h1>
                    <p className={cx(s.profileInfo)}>
                      <span>
                        {data.location} {data.location && ' '}
                        <FormattedMessage {...messages.joinedIn} /> {date}
                      </span>
                    </p>
                    {!isUser && isAuthenticate && (
                      <>
                        <ReportUserModal profileId={profileId} />
                        <Link
                          className='reportUserProfile'
                          onClick={() => dispatch(openReportUserModal())}
                        >
                          <CommonFlagIcon />
                          <FormattedMessage {...messages.reportUser} />
                        </Link>
                        <ThankYouModal />
                      </>
                    )}
                  </div>
                  <div className={cx(s.textAlignRight, 'textAlignLeftRtl')}>
                    {isUser && (
                      <Link to="/user/edit" className={s.editFlex}>
                        <FormattedMessage {...messages.editProfile} />
                        <LinkIndicateIcon className={cx('editIconPayRTL')} />
                      </Link>
                    )}
                  </div>
                </div>

                {data.info && (
                  <>
                    <div className={s.lineCss}></div>
                    <div>
                      <h3 className={s.subTitle}>
                        <FormattedMessage {...messages.aboutMe} />
                      </h3>
                      <p className={cx(s.subContent)}>
                        {!open && count >= 150 && (
                          <span className={cx(s.subText, s.lineBreak)}>
                            {firstArray} {dotString && <span>...</span>}
                          </span>
                        )}
                        {restArray && restArray.length > 0 && (
                          <span>
                            <Collapse in={open}>
                              <div>
                                <span className={cx(s.subText, s.lineBreak)}>
                                  {open && (
                                    <>
                                      {firstArray}
                                      {restArray}
                                    </>
                                  )}
                                </span>
                              </div>
                            </Collapse>
                            {dotString && (
                              <div className={s.btnContainer}>
                                <div className={s.showHidePadding}>
                                  <Button
                                    bsStyle="link"
                                    className={cx(s.button, s.noPadding, s.btnLInk, s.showHideBtn, 'bgTransparent')}
                                    onClick={handleClick}
                                  >
                                    {open ? (
                                      <FormattedMessage {...messages.closeAll} />
                                    ) : (
                                      <FormattedMessage {...messages.showDescription} />
                                    )}
                                    {open ? (
                                      <CommonAngleUpIcon className1={s.navigationIcon} />
                                    ) : (
                                      <CommonAngleDownIcon className2={cx(s.navigationIcon, s.positionTop)} />
                                    )}
                                  </Button>
                                </div>
                              </div>
                            )}
                          </span>
                        )}
                      </p>
                    </div>
                  </>
                )}

                <PanelWrapper userId={data.userId} firstName={data.firstName} />
              </div>

              {data.reviewsCount > 0 && (
                <Reviews
                  reviewsCount={data.reviewsCount}
                  data={data.reviews}
                  loadMore={loadMore}
                  userProfileId={userProfileId}
                />
              )}
            </div>
          </div>
        </div>
      </Grid>
    </div>
  );
};

ViewProfile.propTypes = {
  data: PropTypes.shape({
    userId: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    info: PropTypes.string.isRequired,
    location: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
    picture: PropTypes.string.isRequired,
    profileId: PropTypes.number.isRequired,
    reviewsCount: PropTypes.number.isRequired,
  }).isRequired,
  isUser: PropTypes.bool,
  loadMore: PropTypes.any.isRequired,
  profileId: PropTypes.number.isRequired,
};

export default withStyles(s)(ViewProfile);